if (!customElements.get('sticky-checkout-mobile')) {
  class StickyCheckoutMobile extends HTMLElement {
    constructor() {
      super();
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    connectedCallback() {
      this.defaultButton = document.querySelector('#checkout');
      if (!this.defaultButton) return;

      this.bindOnWindowScroll = this.debounce(this.onWindowScroll.bind(this), 0);
      this.bindOnResize = this.debounce(this.checkViewport.bind(this), 100);

      this.checkViewport();
      window.addEventListener('resize', this.bindOnResize);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.bindOnWindowScroll);
      window.removeEventListener('resize', this.bindOnResize);
    }

    checkViewport() {
      if (window.innerWidth < 990) {
        this.enableScrollListener();
        this.onWindowScroll();
      } else {
        this.disableScrollListener();
        this.classList.add('hide');
      }
    }

    enableScrollListener() {
      if (this.scrollListenerEnabled) return;
      window.addEventListener('scroll', this.bindOnWindowScroll);
      this.scrollListenerEnabled = true;
    }

    disableScrollListener() {
      if (!this.scrollListenerEnabled) return;
      window.removeEventListener('scroll', this.bindOnWindowScroll);
      this.scrollListenerEnabled = false;
    }

    onWindowScroll() {
      const buttonRect = this.defaultButton.getBoundingClientRect();
      const isVisible = buttonRect.top < window.innerHeight && buttonRect.bottom > 0;
      this.classList.toggle('hide', isVisible);
    }
  }

  customElements.define('sticky-checkout-mobile', StickyCheckoutMobile);
}
